import { Component, OnInit } from '@angular/core';
import { MsalHelperService } from '../services/msal-helper.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-failed',
    templateUrl: './failed.component.html',
    standalone: false
})
export class FailedComponent implements OnInit {

  public error: any;
  public QuotaExceededError: boolean = false;

  constructor(
    private msalHelperService: MsalHelperService,
    private route: ActivatedRoute,
    private router: Router
  ) { 

    this.error = this.msalHelperService.getError();
    this.QuotaExceededError = this.route.snapshot.queryParamMap.get('why') == 'QuotaExceededError';

  }

  ngOnInit(): void {
  }

  clearStorage() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

}
